import React from "react";
import Service from '../../service/Service';
const service = new Service();

export default function UserListOverlay({ eleRef }) {
    return (
        <div className="followers-overlay" onClick={(e) => service.closeUserlist(e)}>
            <div className="followers-popup">
                <div className="like-header">
                    <span className="M18_48 followers-title"></span>
                    <span className="closeButton icon" data-icon-font="C" onClick={(e) => service.closeUserlist(e)}></span>
                </div>
                <div className="like-list">
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// src/shared/qna/common/UserListOverlay.js